/**
 * TaskPortalCommentService
 * Service for task comment operations in the portal.
 * Route: api/task-portal/tasks/{taskId}/comments
 */
import { TaskPortalBaseService } from './TaskPortalBaseService';
/**
 * TaskPortalCommentService
 * Handles comment operations for the task portal.
 */
export class TaskPortalCommentService extends TaskPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskPortalCommentService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? TaskPortalCommentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get all comments for a task
     * GET /api/task-portal/tasks/{taskId}/comments
     */
    async getComments(taskId) {
        const response = await this.getCommentsRaw(taskId);
        return response.data ?? [];
    }
    getCommentsRaw(taskId) {
        return this.get(`${taskId}/comments`);
    }
    /**
     * Get a specific comment
     * GET /api/task-portal/tasks/{taskId}/comments/{commentId}
     */
    async getComment(taskId, commentId) {
        const response = await this.getCommentRaw(taskId, commentId);
        if (!response.data) {
            throw new Error(`Comment ${commentId} not found`);
        }
        return response.data;
    }
    getCommentRaw(taskId, commentId) {
        return this.get(`${taskId}/comments/${commentId}`);
    }
    /**
     * Create a new comment
     * POST /api/task-portal/tasks/{taskId}/comments
     */
    async createComment(taskId, data) {
        const response = await this.createCommentRaw(taskId, data);
        if (!response.data) {
            throw new Error('Failed to create comment');
        }
        return response.data;
    }
    createCommentRaw(taskId, data) {
        return this.post(`${taskId}/comments`, data);
    }
    /**
     * Update a comment
     * PUT /api/task-portal/tasks/{taskId}/comments/{commentId}
     * Creators: Can update any comment
     * Assignees: Can only update own comments within 30 minutes
     */
    async updateComment(taskId, commentId, data) {
        const response = await this.updateCommentRaw(taskId, commentId, data);
        if (!response.data) {
            throw new Error('Failed to update comment');
        }
        return response.data;
    }
    updateCommentRaw(taskId, commentId, data) {
        return this.put(`${taskId}/comments/${commentId}`, data);
    }
    /**
     * Delete a comment
     * DELETE /api/task-portal/tasks/{taskId}/comments/{commentId}
     * Creators: Can delete any comment
     * Assignees: Can only delete own comments within 30 minutes
     */
    async deleteComment(taskId, commentId) {
        const response = await this.deleteCommentRaw(taskId, commentId);
        if (!response.success) {
            throw new Error('Failed to delete comment');
        }
    }
    deleteCommentRaw(taskId, commentId) {
        return this.delete(`${taskId}/comments/${commentId}`);
    }
}
TaskPortalCommentService.DEFAULT_SERVICE_PATH = 'tasks';
TaskPortalCommentService.BASE_PATH = 'api/task-portal/tasks';
//# sourceMappingURL=TaskPortalCommentService.js.map